import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { AdminTicketAnswerRoute } from '@/modules/ticket-answer/routes/admin-ticket-answer.route'
import { TicketAnswerRequestModel } from '@/modules/ticket-answer/models/ticket-answer-request.model'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'

@vservice()
export class AdminTicketAnswerService {
  constructor(
    private readonly routes: AdminTicketAnswerRoute
  ) {
  }

  store(id: number, data: TicketAnswerRequestModel) {
    return Inertia.post(
      this.routes.store(id),
      data,
      { preserveScroll: true }
    )
  }

  update(ticketId: number, id: number, data: TicketAnswerRequestModel) {
    return Inertia.post(
      this.routes.update(ticketId, id),
      data,
      { preserveScroll: true }
    )
  }

  destroy(ticketId: number, id: number) {
    return Inertia.delete(
      this.routes.destroy(ticketId, id)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف پیام',
        message: 'آیا از حذف پیام اطمینان دارید ؟'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }

}